module.exports = "/_next/static/images/fingerprints-sprites-6a8f981f76311278c1c4a500b04572e2.png";